module.exports = __webpack_public_path__ + "img/add_items.a325441d.svg";